import React, { Component } from 'react';
import { Container, Dropdown, Image, Menu, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { AUTH_TOKEN, USER } from '../constants';
import logo from '../images/logo.png';
import PermissionsManager from './PermissionsManager';

class Header extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  _logout() {
    localStorage.removeItem(AUTH_TOKEN);
    this.props.history.push('/');
  }

  render() {
    const authToken = localStorage.getItem(AUTH_TOKEN);
    const userEmail = localStorage.getItem(USER);

    if (!authToken) return null;

    return (
      <div>
        <Menu fixed="top">
          <Container>
            <Menu.Item as={Link} header name="home" to="/home">
              <Image
                size="tiny"
                src={logo}
                style={{ height: '50px', width: 'auto' }}
              />
            </Menu.Item>
            <PermissionsManager
              hasPermissions={[
                'create_shop',
                'update_shop',
                'delete_shop',
                'create_event',
                'update_event',
                'delete_event',
                'create_offer',
                'update_offer',
                'delete_offer',
                'create_article',
                'update_article',
                'delete_article',
                'create_author',
                'update_author',
                'delete_author',
                'create_blog',
                'update_blog',
                'delete_blog',
              ]}
            >
              <Dropdown item simple text="Pages">
                <Dropdown.Menu>
                  <PermissionsManager
                    hasPermissions={[
                      'create_shop',
                      'update_shop',
                      'delete_shop',
                    ]}
                  >
                    <Dropdown.Item as={Link} name="shops" to="/shops">
                      Liste des boutiques
                    </Dropdown.Item>
                  </PermissionsManager>
                  <PermissionsManager
                    hasPermissions={[
                      'create_event',
                      'update_event',
                      'delete_event',
                    ]}
                  >
                    <Dropdown.Item as={Link} name="events" to="/events">
                      Liste des événements
                    </Dropdown.Item>
                  </PermissionsManager>
                  <PermissionsManager
                    hasPermissions={[
                      'create_offer',
                      'update_offer',
                      'delete_offer',
                    ]}
                  >
                    <Dropdown.Item as={Link} name="offers" to="/offers">
                      Liste des offres
                    </Dropdown.Item>
                  </PermissionsManager>
                  <PermissionsManager
                    hasPermissions={[
                      'create_office',
                      'update_office',
                      'delete_office',
                    ]}
                  >
                    <Dropdown.Item as={Link} name="offices" to="/offices">
                      Liste des bureaux
                    </Dropdown.Item>
                  </PermissionsManager>
                  <PermissionsManager
                    hasPermissions={[
                      'create_page',
                      'update_page',
                      'delete_page',
                    ]}
                  >
                    <Dropdown.Item as={Link} name="pages" to="/pages">
                      Autres pages
                    </Dropdown.Item>
                  </PermissionsManager>
                  <PermissionsManager
                    hasPermissions={[
                      'create_page_builder',
                      'update_page_builder',
                      'delete_page_builder',
                    ]}
                  >
                    <Dropdown.Item as={Link} name="pages" to="/page-builders">
                      Page builders
                    </Dropdown.Item>
                  </PermissionsManager>
                  <PermissionsManager
                    hasPermissions={['update_practical_info']}
                  >
                    <Dropdown.Item
                      as={Link}
                      name="practicalInfo"
                      to="/practical-info"
                    >
                      Page d'informations pratiques
                    </Dropdown.Item>
                  </PermissionsManager>
                  <PermissionsManager
                    hasPermissions={[
                      'create_question',
                      'update_question',
                      'delete_question',
                    ]}
                  >
                    <Dropdown.Item as={Link} name="questions" to="/questions">
                      FAQ
                    </Dropdown.Item>
                  </PermissionsManager>
                  {/* <PermissionsManager
                    hasPermissions={[
                      'create_article',
                      'update_article',
                      'delete_article',
                      'create_author',
                      'update_author',
                      'delete_author',
                      'create_blog',
                      'update_blog',
                      'delete_blog',
                    ]}
                  >
                    <Dropdown.Item>
                      <i className="dropdown icon" />
                      <span className="text">Blog</span>
                      <Dropdown.Menu>
                        <PermissionsManager
                          hasPermissions={[
                            'create_article',
                            'update_article',
                            'delete_article',
                          ]}
                        >
                          <Dropdown.Item
                            as={Link}
                            name="articles"
                            to="/blog/articles"
                          >
                            Articles
                          </Dropdown.Item>
                        </PermissionsManager>
                        <PermissionsManager
                          hasPermissions={[
                            'create_author',
                            'update_author',
                            'delete_author',
                          ]}
                        >
                          <Dropdown.Item
                            as={Link}
                            name="authors"
                            to="/blog/authors"
                          >
                            Auteurs
                          </Dropdown.Item>
                        </PermissionsManager>
                        <PermissionsManager
                          hasPermissions={[
                            'create_blog',
                            'update_blog',
                            'delete_blog',
                          ]}
                        >
                          <Dropdown.Item as={Link} name="blog" to="/blog">
                            Page
                          </Dropdown.Item>
                        </PermissionsManager>
                      </Dropdown.Menu>
                    </Dropdown.Item>
                  </PermissionsManager> */}
                  <PermissionsManager
                    hasPermissions={[
                      'update_press_kit',
                      'create_press_release',
                      'update_press_release',
                      'delete_press_release',
                    ]}
                  >
                    <Dropdown.Item>
                      <i className="dropdown icon" />
                      <span className="text">Dossier de presse</span>
                      <Dropdown.Menu>
                        <PermissionsManager
                          hasPermissions={[
                            'create_press_release',
                            'update_press_release',
                            'delete_press_release',
                          ]}
                        >
                          <Dropdown.Item
                            as={Link}
                            name="pressRelease"
                            to="/press-releases"
                          >
                            Liste des communiqués de presse
                          </Dropdown.Item>
                        </PermissionsManager>
                        <PermissionsManager
                          hasPermissions={['update_press_kit']}
                        >
                          <Dropdown.Item
                            as={Link}
                            name="pressKit"
                            to="/press-kit"
                          >
                            Page "Dossier de presse"
                          </Dropdown.Item>
                        </PermissionsManager>
                      </Dropdown.Menu>
                    </Dropdown.Item>
                  </PermissionsManager>
                  <PermissionsManager
                    hasPermissions={[
                      'create_contact',
                      'update_contact',
                      'delete_contact',
                      'create_subject',
                      'update_subject',
                      'delete_subject',
                    ]}
                  >
                    <Dropdown.Item>
                      <i className="dropdown icon" />
                      <span className="text">Contact</span>
                      <Dropdown.Menu>
                        <PermissionsManager
                          hasPermissions={[
                            'create_contact',
                            'update_contact',
                            'delete_contact',
                          ]}
                        >
                          <Dropdown.Item as={Link} name="contact" to="/contact">
                            Page
                          </Dropdown.Item>
                        </PermissionsManager>
                        <PermissionsManager
                          hasPermissions={[
                            'create_subject',
                            'update_subject',
                            'delete_subject',
                          ]}
                        >
                          <Dropdown.Item
                            as={Link}
                            name="subjects"
                            to="/contact/subjects"
                          >
                            Sujets
                          </Dropdown.Item>
                        </PermissionsManager>
                      </Dropdown.Menu>
                    </Dropdown.Item>
                  </PermissionsManager>
                  <Dropdown.Item>
                    <i className="dropdown icon" />
                    <span className="text">Passeport Fidelite</span>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        as={Link}
                        name="passportfidelite"
                        to="/passportfidelite"
                      >
                        Page
                      </Dropdown.Item>
                      <Dropdown.Item
                        as={Link}
                        name="passportfidelite_statistique"
                        to="/passportfidelite/list"
                      >
                        Liste des inscrits
                      </Dropdown.Item>
                      <Dropdown.Item
                        as={Link}
                        name="passportfidelite_statistique"
                        to="/passportfidelite/stats"
                      >
                        Statistiques
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown.Item>
                  <PermissionsManager
                    hasPermissions={[
                      'delete_newsletter_subscriber',
                      'get_newsletter_subscribers',
                    ]}
                  >
                    <Dropdown.Item
                      as={Link}
                      name="newsletter-subscribers"
                      to="/newsletter-subscribers"
                    >
                      Newsletter
                    </Dropdown.Item>
                  </PermissionsManager>
                  <PermissionsManager hasPermissions={['update_the_place']}>
                    <Dropdown.Item as={Link} name="thePlace" to="/the-place">
                      Le lieu
                    </Dropdown.Item>
                  </PermissionsManager>
                  {/* <PermissionsManager
                    hasPermissions={[
                      'create_slide',
                      'update_slide',
                      'delete_slide',
                    ]}
                  >
                    <Dropdown.Item as={Link} name="homePwa" to="/home-pwa">
                      Page d'accueil : Slides
                    </Dropdown.Item>
                  </PermissionsManager> */}
                  <Dropdown.Item as={Link} name="hompeage" to="/homepage">
                    Page d'accueil
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </PermissionsManager>
            <PermissionsManager
              hasPermissions={[
                'create_media',
                'update_media',
                'delete_media',
                'create_category',
                'update_category',
                'delete_category',
                'get_users',
                'create_user',
                'update_user',
                'delete_user',
              ]}
            >
              <Dropdown item simple text="Général">
                <Dropdown.Menu>
                  <PermissionsManager
                    hasPermissions={[
                      'create_media',
                      'update_media',
                      'delete_media',
                    ]}
                  >
                    <Dropdown.Item as={Link} name="medias" to="/medias">
                      Médias
                    </Dropdown.Item>
                  </PermissionsManager>
                  <PermissionsManager
                    hasPermissions={[
                      'create_partner',
                      'update_partner',
                      'delete_partner',
                    ]}
                  >
                    <Dropdown.Item as={Link} name="partners" to="/partners">
                      Partenaires
                    </Dropdown.Item>
                  </PermissionsManager>
                  <PermissionsManager
                    hasPermissions={[
                      'create_category',
                      'update_category',
                      'delete_category',
                    ]}
                  >
                    <Dropdown.Item as={Link} name="categories" to="/categories">
                      Catégories
                    </Dropdown.Item>
                  </PermissionsManager>
                  <PermissionsManager hasPermissions={['update_menu']}>
                    <Dropdown.Item as={Link} name="menu" to="/menu">
                      Navigation principale
                    </Dropdown.Item>
                  </PermissionsManager>
                  <PermissionsManager hasPermissions={['update_footer']}>
                    <Dropdown.Item as={Link} name="footer" to="/footer">
                      Navigation footer
                    </Dropdown.Item>
                  </PermissionsManager>
                  <Dropdown.Item
                    as={Link}
                    name="social-networks"
                    to="/social-networks"
                  >
                    Réseaux sociaux
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} name="guides" to="/guides">
                    Audio-guides
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} name="plan" to="/plan">
                    Plan
                  </Dropdown.Item>
                  <PermissionsManager
                    hasPermissions={[
                      'create_access',
                      'update_access',
                      'delete_access',
                      'create_parking',
                      'update_parking',
                      'delete_parking',
                    ]}
                  >
                    <Dropdown.Item>
                      <i className="dropdown icon" />
                      <span className="text">Services</span>
                      <Dropdown.Menu>
                        <PermissionsManager
                          hasPermissions={[
                            'create_service',
                            'update_service',
                            'delete_service',
                          ]}
                        >
                          <Dropdown.Item
                            as={Link}
                            name="services"
                            to="/services"
                          >
                            Services
                          </Dropdown.Item>
                        </PermissionsManager>
                        <PermissionsManager
                          hasPermissions={[
                            'create_access',
                            'update_access',
                            'delete_access',
                          ]}
                        >
                          <Dropdown.Item as={Link} name="access" to="/accesses">
                            Accès
                          </Dropdown.Item>
                        </PermissionsManager>
                        <PermissionsManager
                          hasPermissions={[
                            'create_parking',
                            'update_parking',
                            'delete_parking',
                          ]}
                        >
                          <Dropdown.Item
                            as={Link}
                            name="parking"
                            to="/parkings"
                          >
                            Parkings
                          </Dropdown.Item>
                        </PermissionsManager>
                      </Dropdown.Menu>
                    </Dropdown.Item>
                  </PermissionsManager>
                  <PermissionsManager
                    hasPermissions={[
                      'get_users',
                      'create_user',
                      'update_user',
                      'delete_user',
                    ]}
                  >
                    <Dropdown.Item>
                      <i className="dropdown icon" />
                      <span className="text">Utilisateurs</span>
                      <Dropdown.Menu>
                        <Dropdown.Item as={Link} name="users" to="/users">
                          Listes des utilisateurs
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} name="roles" to="/roles">
                          Roles
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown.Item>
                  </PermissionsManager>
                </Dropdown.Menu>
              </Dropdown>
            </PermissionsManager>
            <Menu.Menu
              position="right"
              style={{ borderRight: '1px solid rgba(34,36,38,.1)' }}
            >
              <Dropdown
                item
                simple
                trigger={
                  <span>
                    <Icon name="user" /> {userEmail}
                  </span>
                }
              >
                <Dropdown.Menu>
                  <Dropdown.Item
                    name="logout"
                    onClick={(event, data) => this._logout()}
                  >
                    Déconnexion
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Menu.Menu>
          </Container>
        </Menu>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js